export const privacyPolicyHtml = `
<p><strong>Effective Date:</strong> December 19, 2025<br>
<strong>Last Updated:</strong> December 19, 2025</p >

<p>Miracle Pace Inc. (“Miracle Pace”, “we”, “our”, or “us”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, store, and safeguard your personal information when you use our website, mobile applications, and financial services (the “Services”).  
By accessing or using the Platform, you consent to the practices described in this Policy.</p >

<h2>1. Introduction</h2>
<p>This Policy governs the collection, use, and disclosure of your personal information when using Miracle Pace services.</p >

<h2>2. Personal Information Collected</h2>
<p>We may collect:</p >
<ul>
<li>Name, date of birth, address, email, phone number, and government-issued identification</li>
<li>Payment and transaction data</li>
<li>KYC/AML verification information</li>
<li>Technical information such as IP address, device type, browser type</li>
<li>Usage data including session logs and click behavior</li>
</ul>

<h2>3. Financial and Transaction Information</h2>
<p>We collect banking details, transaction history, and currency exchange records solely for processing payments and complying with regulatory requirements.</p >

<h2>4. KYC/AML Compliance Data</h2>
<p>Information provided for identity verification, anti-money laundering (AML), and counter-terrorist financing (CTF) compliance is collected and stored securely.</p >

<h2>5. Usage Data</h2>
<p>We collect information about your interaction with the Platform, including session duration, pages visited, and actions performed, to improve services and prevent fraud.</p >

<h2>6. How Information is Used</h2>
<p>Your information is used to:</p >
<ul>
<li>Verify your identity</li>
<li>Process transactions and payments</li>
<li>Communicate updates, alerts, or account information</li>
<li>Improve Platform functionality and user experience</li>
<li>Detect and prevent fraud or illegal activity</li>
<li>Comply with legal and regulatory obligations</li>
</ul>

<h2>7. Stripe & Third-Party Payment Processing</h2>
<p>Miracle Pace services are <strong>completely free</strong>. Payments are processed by third-party providers (e.g., Stripe).</p >
<ul>
<li>Stripe may charge processing fees, <strong>paid directly by users</strong>.</li>
<li>Miracle Pace does <strong>not</strong> collect, mark up, or profit from Stripe fees.</li>
<li>Users acknowledge that final transaction amounts may differ slightly due to third-party fees or market fluctuations.</li>
<li><strong>Important Disclaimer:</strong> Miracle Pace acts only as a conduit for transactions and does <strong>not</strong> assume responsibility for the outcome of any transaction processed through the Platform or third-party providers.</li>
</ul>

<h2>8. Data Sharing & Disclosure</h2>
<p>We do not sell or trade your personal information. We may share data:</p >
<ul>
<li>With authorized third-party service providers (Stripe, AWS, compliance partners)</li>
<li>When required by law, court order, or regulatory authority</li>
<li>In the event of a merger, acquisition, or business transfer</li>
</ul>

<h2>9. Data Storage</h2>
<p>KYC and personal data are securely stored on encrypted servers (e.g., AWS). Payment information is processed via Stripe; Miracle Pace does not store full banking or card details.</p >

<h2>10. Data Retention</h2>
<p>Data is retained only as long as necessary for legal, regulatory, or operational purposes. Once no longer required, data is securely deleted or anonymized.</p >

<h2>11. Data Security</h2>
<p>We employ encryption, access controls, monitoring, and industry-standard security measures to protect your information.</p >

<h2>12. Limitation of Liability</h2>
<p>While we implement robust security, no system is completely secure. Miracle Pace is not liable for unauthorized access or loss beyond reasonable control.</p >

<h2>13. User Rights</h2>
<p>You have rights to:</p >
<ul>
<li>Access your personal data</li>
<li>Correct inaccurate information</li>
<li>Delete information where legally permitted</li>
<li>Withdraw consent</li>
<li>File complaints via <strong>miraclepaceinc@outlook.com</strong></li>
</ul>

<h2>14. Cookies & Analytics</h2>
<p>Cookies are used to enhance user experience and for analytics. Disabling cookies may limit functionality of the Platform.</p >

<h2>15. Children’s Privacy</h2>
<p>Our Services are not intended for users under 18. We do not knowingly collect personal information from minors.</p >

<h2>16. International Data Transfers</h2>
<p>Data may be stored or processed in Canada or the United States, with appropriate safeguards to protect privacy.</p >

<h2>17. Changes to This Privacy Policy & Contact</h2>
<ul>
<li>We may update this Policy at any time; updates will be posted on the Platform.</li>
<li>Continued use of the Platform constitutes acceptance of updated terms.</li>
<li>Contact: Miracle Pace Inc., 1200 Bay Street, Suite 1201, Toronto, Ontario, Canada, Email: <strong>miraclepaceinc@outlook.com</strong></li>
</ul>
`;
